// Build a properly formatted referral link from an affiliate code

export function buildReferralLink(affiliateCode) {
  const url = new URL('/signup', window.location.origin);
  url.searchParams.set('ref', affiliateCode.trim());
  return url.toString();
}
